import { ChangeDetectionStrategy, Component, EventEmitter, inject, Output } from '@angular/core';
import { takeUntil } from 'rxjs';
import { BaseResizableComponent } from '@src/app/modules/base';

import { LpProductRequestService } from '../services/lp-product-request.service';

@Component({
  selector: 'lp-product-request-list',
  templateUrl: './lp-product-request-list.component.html',
  styleUrls: ['./lp-product-request-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LpProductRequestListComponent extends BaseResizableComponent {
  private readonly lpProductRequestsService = inject(LpProductRequestService);

  @Output() startCreate = new EventEmitter<void>();
  @Output() onSelectItem = new EventEmitter<string>();

  loading = true;

  readonly productRequests$ = this.lpProductRequestsService.productRequests$;

  override ngOnInit(): void {
    super.ngOnInit();

    this.refresh();

    this.productRequests$.pipe(takeUntil(this.destroyed$$)).subscribe(items => {
      this.loading = !items;

      if (items && !items.length) {
        this.startCreate.emit();
      }

      this.cdr.markForCheck();
    });
  }

  refresh() {
    this.lpProductRequestsService.resetProductRequests();
    this.loading = true;
    this.cdr.markForCheck();

    this.lpProductRequestsService.loadProductRequests().subscribe();
  }
}
